import brandPortalOrdersbrandOrderToken from "@faire/web-api/routes/brand-portal/orders/brandOrderToken";
import brandPortalOrdersbrandOrderTokenOrderInvoice from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/order-invoice";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var InvoiceDetailsIA = function InvoiceDetailsIA(_ref) {
  var isAusOrEurBrand = _ref.isAusOrEurBrand,
    brandOrderToken = _ref.brandOrderToken;
  if (isAusOrEurBrand && brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+HEyjw",
      defaultMessage: [{
        "type": 0,
        "value": "We sturen je bestelfacturen voor elke bestelling die je ontvangt op Faire. Facturen worden afgerond zodra de bestelling is verzonden. Je kunt een bestelfactuur vinden door naar "
      }, {
        "children": [{
          "type": 0,
          "value": "Bestellingen"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": " te gaan, naar een specifieke "
      }, {
        "children": [{
          "type": 0,
          "value": "bestellingspagina"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": " te gaan en op Bestelfactuur te klikken."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          return _OrderLinkFormatting(chunks, brandOrderToken);
        },
        InvoiceLinkFormatting: function InvoiceLinkFormatting(chunks) {
          return invoiceLinkFormatting(chunks, brandOrderToken);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "RFmrRL",
      defaultMessage: [{
        "type": 0,
        "value": "Je ontvangt geen bestelfacturen. Je kunt echter je uitbetalingsoverzicht raadplegen op de "
      }, {
        "children": [{
          "type": 0,
          "value": "bestellingspagina"
        }],
        "type": 8,
        "value": "OrderLinkFormatting"
      }, {
        "type": 0,
        "value": " en je eigen factuur genereren op basis van de verstrekte gegevens. Als je ervoor kiest om je eigen factuur te maken, vergeet dan niet dat deze alleen voor intern gebruik is en niet naar Faire of een retailer mag worden gestuurd."
      }],
      values: {
        OrderLinkFormatting: function OrderLinkFormatting(chunks) {
          return _OrderLinkFormatting(chunks, brandOrderToken);
        }
      }
    })));
  }
};
var _OrderLinkFormatting = function _OrderLinkFormatting(chunks, brandOrderToken) {
  if (!brandOrderToken) {
    return /*#__PURE__*/React.createElement(Bold, null, chunks);
  } else {
    return /*#__PURE__*/React.createElement(Button, {
      variant: "tertiary",
      linkTo: brandPortalOrdersbrandOrderToken(brandOrderToken),
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Bold, null, chunks));
  }
};
var invoiceLinkFormatting = function invoiceLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenOrderInvoice(brandOrderToken),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};